import { createFileRoute } from '@tanstack/react-router';
import FuelLevelPercOnline from '../../../components/Graphs/FuelLevelPerc';

export const Route = createFileRoute('/_authenticated/graphs/fuel-level-percentage/$vehicleId')({
  beforeLoad: ({ context }) => {
    // requirePermission(PERMISSION_RIDES, ['read']);
    return {
      ...context,
      documentTitle: {
        main: 'widget.fuelLevel.tooltip',
        params: { valueType: '%' },
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: FuelLevelPercentageGraphRoute,
});

function FuelLevelPercentageGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <FuelLevelPercOnline vehicleId={Number(vehicleId)} isPage />;
}
